import AWS from 'aws-sdk';
import config from '../config';

/**
* @desc saving imageUrl of the user in localstorage
* @param imageUrl
* @return null
*/
const getS3ImageUrl = (imageUrl, loggedInUser) => {
  AWS.config.update({
    region : config.cognito.region
  });
  
  let logins = {}
  logins['cognito-idp.'+ config.cognito.region +'.amazonaws.com/' + config.cognito.userPool] = loggedInUser.storage['CognitoIdentityServiceProvider.'+ config.cognito.clientId +'.' + loggedInUser.username + '.idToken'];
  // Add the User's Id Token to the Cognito credentials login map.
  AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: config.cognito.identityPool,
      Logins: logins
  });
        
  let S3 = new AWS.S3();
  return new Promise(function(resolve, reject) {
    S3.getSignedUrl('getObject', { Bucket: config.cognito.bucketName , Key: imageUrl}, function(err, data) {
      if (err) {
        reject(err);
      } else {          
        resolve(data);
      }
    });
  });
}

export default getS3ImageUrl;


// WEBPACK FOOTER //
// ./src/lib/s3FileHandler.js